<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="scss">
  @import '@/styles/style.scss';
</style>

<script>
import scrollingActions from '@/util/scrollingActions';

export default {
  name: 'app',
  data() {
    return {
    };
  },
  async mounted() {
    scrollingActions();
    window.onload = () => { scrollingActions(); };
    window.onscroll = () => { scrollingActions(); };
  },
};
</script>
